import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import CustomerSupportForm from './CustomerSupportForm.js';

const CustomerSupportFormContainer = (props)=>{
    const { getLabel , locale  } = useIntl();
    const formLabels = React.useMemo(()=>({
            title: getLabel('customersupport.form.title'),
            firstName: {
                label: getLabel('customersupport.firstName.label'),
                placeholder: getLabel('customersupport.firstName.placeholder'),
                errorMessage: getLabel('customersupport.firstName.errorMessage')
            },
            lastName: {
                label: getLabel('customersupport.lastName.label'),
                placeholder: getLabel('customersupport.lastName.placeholder'),
                errorMessage: getLabel('customersupport.lastName.errorMessage')
            },
            email: {
                label: getLabel('customersupport.email.label'),
                placeholder: getLabel('customersupport.email.placeholder'),
                errorMessage: getLabel('customersupport.email.errorMessage')
            },
            topicList: {
                label: getLabel('customersupport.topicList.label'),
                placeholder: getLabel('customersupport.topicList.placeholder'),
                errorMessage: getLabel('customersupport.topicList.errorMessage')
            },
            description: {
                label: getLabel('customersupport.description.label'),
                placeholder: getLabel('customersupport.description.placeholder'),
                errorMessage: getLabel('customersupport.description.errorMessage')
            },
            phoneNumber: {
                label: getLabel('customersupport.phoneNumber.label'),
                placeholder: getLabel('customersupport.phoneNumber.placeholder'),
                errorMessage: getLabel('customersupport.phoneNumber.errorMessage')
            },
            customerID: {
                label: getLabel('customersupport.customerID.label'),
                placeholder: getLabel('customersupport.customerID.placeholder'),
                errorMessage: getLabel('customersupport.customerID.errorMessage')
            },
            submitButtonLabel: getLabel('customersupport.submit.label')
        })
    , [
        locale
    ]);
    return /*#__PURE__*/ React.createElement(CustomerSupportForm, swcHelpers.extends({}, props, {
        labels: formLabels
    }));
};

export { CustomerSupportFormContainer as default };
//# sourceMappingURL=CustomerSupportFormContainer.js.map
